"use client";

import Image from "next/image";
import { BlockProps } from "../BlocksManager/registry";
import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

type VariantStyle = {
  border: string;
};

const variantStyles: Record<string, VariantStyle> = {
  bleu: {
    border:
      "border-b-2 border-b-blue hover:shadow-[0_18px_40px_rgba(0,0,0,0.08)]",
  },
  jaune: {
    border:
      "border-b-2 border-b-yellow hover:shadow-[0_18px_40px_rgba(0,0,0,0.08)]",
  },
  orange: {
    border:
      "border-b-2 border-b-orange hover:shadow-[0_18px_40px_rgba(0,0,0,0.08)]",
  },
  verte: {
    border:
      "border-b-2 border-b-green hover:shadow-[0_18px_40px_rgba(0,0,0,0.08)]",
  },
};

function getVariantStyle(variante?: string) {
  const key = variante?.toLowerCase?.().trim() || "bleu";
  return variantStyles[key] || variantStyles.bleu;
}



export default function AvantagesEntreprise({ data }: BlockProps) {
  if (!data) return null;

  const items = data?.avantages || [];
  const [currentIndex, setCurrentIndex] = useState(0);

  const goLeft = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? items.length - 1 : prevIndex - 1
    );
  };

  const goRight = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === items.length - 1 ? 0 : prevIndex + 1
    );
  };
const desktopGridClass =
  items.length === 3 ? "lg:grid-cols-3" : "lg:grid-cols-4";
  return (
    <section className="bg-violet-light py-10 md:py-20" key={data.id}>
      <div className="container">
        <h2 className=" font-literata text-[32px] font-bold leading-[1.3] text-black lg:text-[54px]">
          {data.titre}
        </h2>

        {/* Desktop */}
        <div className={`mt-12 hidden gap-6 md:grid md:grid-cols-1 ${desktopGridClass}`}>
          {items.map((item: any) => {
            const style = getVariantStyle(item.variante);
            const iconUrl = item?.icon?.url;

            return (
              <article
                key={item.id}
                className={`rounded-[32px] border-b-[4px] bg-white px-8 pb-8 pt-10 ${style.border}`}
              >
                <div className="relative h-[100px] w-[100px] ">
                  {iconUrl && (
                    <Image
                      src={iconUrl}
                      alt={item?.icon?.alternativeText || item.titre}
                      fill
                      className="object-contain"
                    />
                  )}
                </div>

                <h3 className="mt-6 text-[24px] font-bold leading-[1.15] text-black md:text-[28px]">
                  {item.titre}
                </h3>

                <p className="mt-5 text-[18px] leading-[1.35] text-black/85 md:text-[22px]">
                  {item.description}
                </p>
              </article>
            );
          })}
        </div>

        {/* Mobile */}
        <div className="relative mt-8 md:hidden">
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-300 ease-in-out"
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
              {items.map((item: any) => {
                const style = getVariantStyle(item.variante);
                const iconUrl = item?.icon?.url;

                return (
                  <div key={item.id} className="w-full shrink-0 px-1">
                    <article
                      className={`rounded-[32px] border-b-[4px] bg-white px-8 py-5 ${style.border}`}
                    >
                      <div className="relative h-[80px] w-[80px]">
                        {iconUrl && (
                          <Image
                            src={iconUrl}
                            alt={item?.icon?.alternativeText || item.titre}
                            fill
                            className="object-contain"
                          />
                        )}
                      </div>

                      <h3 className="pt-4 text-[24px] font-bold leading-[1.15] text-black">
                        {item.titre}
                      </h3>

                      <p className="pt-4 text-[18px] leading-[1.35] text-black/85">
                        {item.description}
                      </p>
                    </article>
                  </div>
                );
              })}
            </div>
          </div>

          {items.length > 1 && (
            <div className="mt-4 flex items-center  justify-center gap-6">
              <button
                type="button"
                onClick={goLeft}
                className="flex h-11 w-11 items-center justify-center rounded-full bg-white shadow-md"
              >
                <ChevronLeft className="h-5 w-5 text-black" />
              </button>

              <div className="flex gap-2">
                {items.map((_: any, i: number) => (
                  <button
                    key={i}
                    type="button"
                    onClick={() => setCurrentIndex(i)}
                    className={`h-2 w-2 rounded-full transition-all ${
                      i === currentIndex ? "w-5 bg-blue" : "bg-blue/30"
                    }`}
                  />
                ))}
              </div>

              <button
                type="button"
                onClick={goRight}
                className="flex h-11 w-11 items-center justify-center rounded-full bg-white shadow-md"
              >
                <ChevronRight className="h-5 w-5 text-black" />
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}